export default __webpack_public_path__ + "static/media/eye-filled2.8a0cbb92.svg";